import { HttpContext, HttpContextToken } from '@angular/common/http'

export interface ISSRCacheContext {
    enabled: boolean
}

export interface SsrCacheContext {
    context?: HttpContext
    enabled: boolean
}
export const IS_SSR_CACHE_ENABLED = new HttpContextToken<ISSRCacheContext>(() => ({
    enabled: false,
    key: '',
}))

export function withSSrCache(options: SsrCacheContext = { enabled: true }) {
    const { context, ...data } = options
    return (context ?? new HttpContext()).set(IS_SSR_CACHE_ENABLED, {
        ...data,
    })
}
